import { useCallback, useRef, useEffect } from "react";
import { useAuth } from "react-oidc-context";

export function useGetAccessToken(): () => Promise<string | undefined> {
  const auth = useAuth();
  const tokenRef = useRef(auth.user?.access_token);

  // Keep the ref updated with the latest token.
  useEffect(() => {
    tokenRef.current = auth.user?.access_token;
  }, [auth.user?.access_token]);

  return useCallback(async () => tokenRef.current, []);
}